<template>
    <div>
        <PageHeaderLayout>
            <div class="main-page-content">
                <el-row class="table-search">
                    <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
                        <el-form-item label="公司名称">
                            <el-input v-model="searchCondition.company_name" placeholder="输入公司名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="办理状态" prop="c_type">
                            <el-select v-model="searchCondition.status" filterable clearable placeholder="请选择">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="手机号码">
                            <el-input v-model="searchCondition.contact_phone" placeholder="输入手机号码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="时间">
                            <DatePicker @dataSearch="dataSearch" :disabled="disabled"/>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchButton" :disabled="disabled" >查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
                    <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
                    </el-tab-pane>
                </el-tabs>
                <ApeTable v-permission:company_examine_list ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData"  @switchPaging="switchPaging" highlight-current-row>
                    <el-table-column
                        slot="first-column"
                        width="180"
                        align="center"
                        label="ID">
                        <template slot-scope="scope">
                            {{ scope.row.id }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        :label="project_status?'用工企业':'公司名称'">
                        <template slot-scope="scope">
                            {{ scope.row.company_name }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        :label="project_status?'企业联系手机号':'公司负责人手机号'">
                        <template slot-scope="scope">
                            {{ scope.row.contact_phone }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="240"
                        align="center"
                        label="企业资质（营业执照/企业授权书）">
                        <template slot-scope="scope">
                            <el-image :preview-src-list="[scope.row.business_license]" class="expressImg" :src="scope.row.business_license" style="height: 50px;width: 80px;">
                                <template #error>
                                  <div class="image-slot" @click="mxGoUrl(scope.row.business_license)">
                                    查看图片
                                  </div>
                                </template>
                            </el-image>
                            <el-image :preview-src-list="[item]" class="expressImg" :src="item" v-for="(item,index) in scope.row.authorization" v-bind:key="index" style="margin-left: 10px;height: 50px;width: 80px;">
                                <template #error>
                                  <div class="image-slot" @click="mxGoUrl(scope.row.business_license)">
                                    查看图片
                                  </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="!project_status"
                        width="240"
                        align="center"
                        label="人力资源许可证/劳务派遣证">
                        <template slot-scope="scope">
                            <div>
                                <el-image :preview-src-list="[scope.row.human_resources_license]" v-if="scope.row.human_resources_license" class="expressImg" :src="scope.row.human_resources_license" style="height: 50px;width: 80px;">
                                    <template #error>
                                      <div class="image-slot" @click="mxGoUrl(scope.row.business_license)">
                                        查看图片
                                      </div>
                                    </template>
                                </el-image>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="申请时间">
                        <template slot-scope="scope">
                            {{ scope.row.updated_at }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="状态">
                        <template slot-scope="scope">
              <!-- <div v-if="scope.row.user==null">数据不完整</div> -->
                            <div v-if="project_status">
                                <div>
                                    {{ scope.row.status=='2'?'资质审核拒绝':scope.row.status=='1'?'资质审核通过':'资质待审核'}}
                                </div>
                                <!-- <div>
                                    {{ scope.row.project_status>0?'项目有待审核':''}}
                                </div> -->
                            </div>
                            <div v-else>
                                {{ scope.row.status=='2'?'资质审核拒绝':scope.row.status=='1'?'资质审核通过':'资质待审核'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="buttonType=='text'"
                        width="350"
                        header_align='center'
                        align='center'
                        label="操作">
                        <template slot-scope="scope">
                            <span>
                                <el-button v-if="scope.row.status=='1'" v-permission:company_mini_appSetting size="mini" type="text" @click="openMiniapp(scope.row)">配置小程序</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </ApeTable>
            </div>
        </PageHeaderLayout>
        <!-- 创建弹框 -->
        <ModalDialog :dialogData="miniappSetDialogData" @dialogConfirm="miniappSetConfirm" @dialogClose="esignClose">
            <template slot="content">
                <el-form :model="fromData" :rules="fromDatas" ref="fromData" label-position="right" label-width="120px">
                    <el-form-item label="应用程序" prop="name">
                        <el-input type="text" v-model="fromData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="小程序AppId" prop="app_id">
                        <el-input :disabled="updateType=='edit'" type="number" v-model="fromData.app_id"></el-input>
                    </el-form-item>
                    <el-form-item label="小程序KEY" prop="app_key">
                        <el-input type="text" v-model="fromData.app_key"></el-input>
                    </el-form-item>
                    <el-form-item label="小程序秘钥" prop="app_secret">
                        <el-input type="text" v-model="fromData.app_secret"></el-input>
                    </el-form-item>
                    <el-form-item label="小程序状态" prop="status">
                        <el-radio v-model="fromData.status" :label="1">启用</el-radio>
                        <el-radio v-model="fromData.status" :label="2">禁用</el-radio>
                    </el-form-item>
                    <el-form-item label="小程序logo" prop="logo">
                        <uploadRechargeImg :imageUrl="fromData.logo" @handleSuccess='RechargImgSuccess($event,"logo")' @handleRemove='RechargImgRemove($event,"logo")' :ossData='ossData' :ossObj="ossObj" class="upload-item"></uploadRechargeImg>
                    </el-form-item>
                </el-form>
            </template>
        </ModalDialog>
        <!-- 小程序列表 -->
        <ModalDialog :dialogData="miniappDialogData" @dialogConfirm="miniAppListClose" @dialogClose="miniAppListClose">
            <template slot="content">
                <div style="text-align: right;margin: 5px 0;">
                    <el-button v-permission:company_mini_add type="primary" @click="addMiniapp">新增</el-button>
                </div>
                <el-table v-permission:company_mini_list border ref="miniappList" :data="miniappList" :columns="columns" :loading="loadingStaus" highlight-current-row>
                      <el-table-column
                          align="center"
                          label="小程序名称">
                          <template slot-scope="scope">
                              {{ scope.row.name }}
                          </template>
                      </el-table-column>
                      <el-table-column
                          align="center"
                          label="AppID">
                          <template slot-scope="scope">
                              {{ scope.row.id }}
                          </template>
                      </el-table-column>
                      <el-table-column
                          width="350"
                          header_align='center'
                          align='center'
                          label="操作">
                          <template slot-scope="scope">
                              <span>
                                <el-button v-permission:company_mini_edit size="mini" type="text" @click="editMiniappInfo(scope.row)">配置</el-button>
                                <el-popover
                                   v-permission:company_mini_settingDelete
                                   :ref="'el_popover'+scope.row.id"
                                   placement="top"
                                   width="150">
                                   <p>确定要删除记录吗？</p>
                                   <div style="text-align: right; margin: 0;">
                                     <el-button type="text" size="medium" @click="$refs['el_popover'+scope.row.id].doClose()">取消</el-button>
                                     <el-button type="danger" size="small" @click="deleteButton(scope.row.id)">确定</el-button>
                                   </div>
                                   <el-button v-permission:company_mini_settingDelete slot="reference" type="danger" size="mini">删除</el-button>
                                </el-popover>
                              </span>
                          </template>
                      </el-table-column>
                  </el-table>
            </template>
        </ModalDialog>
    </div >
</template>

<script>
    
import uploadRechargeImg from './uploadRechargeImg.vue'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        uploadRechargeImg,
        PageHeaderLayout,
        ApeDrawer,
        ApeTable,
        ApeUploader,
        ModalDialog,
        DatePicker
    },
    data() {
        return {
            updateType:'add',
            ossData: {},
            ossObj: {},
            miniappList:[],
            disabled: false,
            activeName: 'all',
            tabsList: [
                {
                    label: '用工企业',
                    name: 'all'
                },
                {
                    label: '人力资源公司',
                    name: 'cancel'
                },
            ],
            // 搜索条件
            searchCondition:{
                status:'',
                contact_phone:'',
                time:'',
                company_name:''
            },
            typeList:[
                {id:'0',name:'资质待审核'},
                {id:'1',name:'资质已通过'},
                {id:'2',name:'资质未通过'}
            ],
            loadingStaus: false,
            columns: [],
            // 表格列表数据
            dataList:[],
            // 分页信息
            pagingData:{
                is_show: true,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0
            },
            // 分页的offset,序号列使用
            offset:0,
            // 已上传文件列表
            uploadFileList:[],
            // 附件列表
            attachmentList:[],
            // 添加附件
            dialogData:{
                visible: false,
                title: '系统提示',
                width: '35%',
                loading: false,
                modal: false
            },
            project_status:true,
            refuseData:{
                reason:'抱歉，您当前没有通过企业资质审核'
            },
            refuseRules: {
                // reason: [
                //     { required: true, message: '请输入拒绝原因', trigger: 'blur' },
                // ]
            },
            fromDatas:{
                name: [
                    { required: true, message: '小程序名称不能为空', trigger: 'blur' },
                ],
                app_id: [
                    { required: true, message: '小程序app_id不能为空', trigger: 'blur' },
                ],
                app_key: [
                    { required: true, message: '小程序key不能为空', trigger: 'blur' },
                ],
                app_secret: [
                    { required: true, message: '小程序秘钥不能为空', trigger: 'blur' },
                ],
                status: [
                    { required: true, message: '小程序状态必选', trigger: 'blur' },
                ]
            },
            miniappSetDialogData:{
                visible: false,
                title: '小程序配置',
                width: '50%',
                loading: false,
                modal: false
            },
            miniappDialogData:{
                visible: false,
                title: '小程序列表',
                width: '50%',
                loading: false,
                modal: false
            },
            fromData:{},
            esignLoading:""
        }
    },
    computed: {
        ...mapGetters(['buttonType'])
    },
    watch: {
        "$route.matched" : function(n,o) {
            console.log(n,o)
            if (n.length === 2) {
                this.init()
            }
            this.updateStatus(this.$route.query.project_status??true);
        }
    },
    methods: {
        // 删除
        async deleteButton(id) {
            let res = {}
          if(this.project_status) {
              res = await this.$api.deleteEmploymentMiniappList(id,{
                  id
              })
          } else {
              res = await this.$api.deleteHrMiniappList(id,{
                  id
              })
          }
          if(res) {
            this.$message.success('删除成功')
            this.getMiniappList()
            this.$refs['el_popover'+id].doClose()
          }
        },
        // 重置分页
        async resetPage() {
            this.$refs.apeTable.currentPage = 1
        },
        //点击tab切换
        async handleClick(tab) {
            // this.searchCondition={status:'',contact_phone:'',time:'',company_name:''};
            this.resetPage()
            if (tab.name == 'all') { // 全部批次
                // this.searchCondition.status = tab.name
                this.activeName = tab.name;
                this.init('all')
            } else if(tab.name == 'cancel') {  // 作废批次
                // this.searchCondition.status = tab.name
                this.init('cancel')
            }
        },
        // 搜索
        searchButton() {
            this.resetPage()
            this.init('search')
        },
        // 切换页码操作
        async switchPaging() {
            this.init()
        },
        //获取选中日期的值
        dataSearch(value) {
            this.searchCondition.time_value = value
        },
        // 初始化列表
        async init(type) {
            if(type=='cancel') {
                this.project_status = false;
            } else if(type=='all'){
                this.project_status = true;
            }
            this.loadingStaus=true
            let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
            let searchCondition = this.handleSearchCondition()
            Object.assign(searchCondition,pagingInfo)
            this.dataList = []
            if(!this.project_status) {
                this.hrList(searchCondition);
            } else {
                this.employList(searchCondition);
            }
            this.loadingStaus=false
        },
        // 用工企业列表数据
        async employList(searchCondition) {
            
            let {items, total}= await this.$api.getPaihuoEmploymentList(searchCondition)
            this.$nextTick(() => {
                this.dataList=items
            })
            this.pagingData.total = total
            this.offset = searchCondition.current_page
        },
        // 人力资源公司列表数据
        async hrList(searchCondition) {
            let {items, total}= await this.$api.getPaihuoHumanResourcesList(searchCondition)
            this.$nextTick(() => {
                this.dataList=items
                items.forEach(function(item,index){
                    if(item.authorization&&item.authorization[1]) {
                        items[index].authorization_img = item.authorization[1];
                    } else {
                        items[index].authorization_img = "";
                    }
                })
            })
            this.pagingData.total = total
            this.offset = searchCondition.current_page
        },
        // 处理搜索条件
        handleSearchCondition() {
            let condition = {}
            if (this.searchCondition.status) {
                condition.status = this.searchCondition.status
            }
            if (this.searchCondition.contact_phone) {
                condition.contact_phone = this.searchCondition.contact_phone
            }
            if (this.searchCondition.time_value) {
                condition.start_time = this.searchCondition.time_value[0]
                condition.end_time = this.searchCondition.time_value[1]
            }
            if (this.searchCondition.company_name) {
                condition.company_name = this.searchCondition.company_name
            }
            return condition
        },
        keyupSubmit(){
            document.onkeydown = e => {
                console.log(e)
                let _key=window.event.keyCode;
                if(_key === 13){
                    this.searchButton()
                }
            }
        },
        // 处理模态框，确定事件
        handleConfirm() {
            // 调用组件的数据验证方法
            this.$refs['refuseForm'].validate((valid) => {
                if (valid) {
                    if(!this.refuseData.status) {
                        this.$message.error('请选择审核通过或拒绝！')
                        return false;
                    }
                    if(this.refuseData.status==1) {
                        this.refuseData.reason = "";
                    }
                this.formRefuseSubmit()
                } else {
                    this.$message.error('数据验证失败，请检查必填项数据！')
                }
            })
        },
        async updateStatus(project_status){
            this.project_status = project_status;
        },
        async openMiniapp(row){
            this.company_id = row.id
            await this.getMiniappList()
            this.miniappDialogData.visible = true
        },
        //移除
        RechargImgRemove(url, param) {
            if(param == 'logo'){
                this.fromData.logo = ''
                return false
            }
        },
        //成功
        RechargImgSuccess(url, param) {
            if(param == 'logo'){
                this.fromData.logo = url
                return false
            }
        },
        async ossUpload() {
            const res_oss = await this.$api.getOss({
                dir: 'ph/hr/'
            })
            if (res_oss) {
                this.ossObj = res_oss
                this.ossData = {
                    ossAccessKeyId: res_oss.accessid,
                    policy: res_oss.policy,
                    signature: res_oss.signature
                }
            } else {
                this.$message.error('获取oss签名失败')
            }
        },
        async addMiniapp(){
          this.updateType = 'add';
            this.fromData = {}
            await this.ossUpload()
            this.miniappSetDialogData.visible = true
        },
        async getMiniappList(){
            var list = []
            if(this.project_status) {
                list = await this.$api.getEmploymentMiniappList(this.company_id,{})
            } else {
                list = await this.$api.getHrMiniappList(this.company_id,{})
            }
            this.miniappList = list || []
            console.log(list,'小程序列表')
        },
        // 创建e签宝数据
        async editMiniappInfo(row){
            console.log(row,"row")
            this.updateType = 'edit';
            this.fromData = {
                name:row.name,
                app_id:row.id,
                app_key:row.app_key?row.app_key:'',
                app_secret:row.app_secret?row.app_secret:'',
                status:row.status?row.status:'',
                logo:row.logo?row.logo:'',
            }
            await this.ossUpload()
            this.miniappSetDialogData.visible = true
        },
        // E签宝处理模态框，关闭事件
        miniAppListClose() {
            this.miniappDialogData.visible = false
            this.fromData = {}
            this.company_id = ''
        },
        // E签宝处理模态框，关闭事件
        esignClose() {
            this.miniappSetDialogData.visible = false
            this.fromData = {}
        },
        // E签宝处理模态框，确定事件
        miniappSetConfirm() {
            this.$refs["fromData"].validate((valid) => {
                if (valid) {
                    var that = this;
                    that.miniappSetDialogData.loading = true;
                    that.submitCreateMiniapp();
                    setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
                        that.miniappSetDialogData.loading = false;
                    },3000)
                } else {
                    this.$message.warning('请先正确填写信息');
                    return false;
                }
            });
            
        },
        // 创建e签宝数据提交
        async submitCreateMiniapp() {
            let res = {}
            if(this.project_status) {
              if(this.updateType == 'add'){
                res = await this.$api.createEmploymentMiniappInfo(this.company_id,this.fromData)
              }else{
                res = await this.$api.editEmploymentMiniappInfo(this.company_id,this.fromData)
              }
            } else {
              if(this.updateType == 'add'){
                res = await this.$api.createHrMiniappInfo(this.company_id,this.fromData)
              }else{
                res = await this.$api.editHrMiniappInfo(this.company_id,this.fromData)
              }
            }
            if (res) {
                this.$message.success('操作成功。')
                this.miniappSetDialogData.loading = false;
                this.miniappSetDialogData.visible = false
                this.fromData = {}
                this.getMiniappList()
            } else {
                this.$message.error('创建失败。')
            }
            return false;
        }
    },
    created() {
        this.keyupSubmit()
    },
    mounted() {
        this.resetPage()
        this.init();
        this.updateStatus(true);
    },
}
</script>
<style lang="stylus">
    .el-tooltip__popper
        max-width:70%
    .image-slot{
        height: 50px
        width: 80px
        display:flex
        align-items:center
        justify-content:center
    }
</style>
<style lang="stylus" scoped>
    .virtual_account 
        margin-right: 10px
    .expressImg
        width:100px
        height:auto
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .submitBtn
    float: right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .iconBtns
    font-size: 20px
    color: rgba(0, 183, 158, 1)
  .warning-tips
    padding: 15px 5px
    padding-bottom: 25px
    color: #E6A23C
    font-size: 16px
  .error-tips
    font-size: 16px
    padding: 15px 5px
    padding-bottom: 25px
  .filterBlur
    filter: blur(5px)
    -moz-filter: blur(5px)
    -webkit-filter: blur(5px)
  .icon-btn
    font-size: 45px
  /deep/.el-alert__icon
    font-size: 45px
    margin-left: -15px
  /deep/.el-alert__content
    margin-left: 40px
  /deep/.el-alert__title
    font-size: 16px
  /deep/.el-alert
    padding: 0px 25px
  /deep/.el-alert--error.is-light,
  /deep/.el-alert--warning.is-light
    background: #fff
  /deep/.el-alert__title.is-bold
    font-weight: normal
  /deep/.el-alert__description
    font-size: 16px
  /deep/.el-alert__title
    line-height: 30px
  .tips-center
    justify-content: center
    // .table-search
    
</style>
